export default {
  loading: false,
  notificationSnackbar: false,
  notificationSnackbarText: '',
  breadcrumbCurrentView: '',
  breadcrumbCurrentSubView: '',
  viewRequiresAuth: true,
  audioPlayerIsPlaying: false,
  audioPlayerIsLoading: false,
  audioPlayerFileKey: null,
}
